@let roundedPercentage = percentage() | number: "1.0-0";
@if (percentage() >= 0) {
  @if (showPercentage()) {
    <div class="pb-1 text-end text-[17px]">{{ roundedPercentage }} %</div>
  }
  <div class="h-6 w-full overflow-hidden rounded-md border border-black bg-white desk:h-7">
    <div class="h-full bg-black" [style.width.%]="percentage()"></div>
  </div>
}
